import ValueEditorProperty from './ValueEditorProperty';

export default ValueEditorProperty;
export { ValueEditorProperty };
